/**
    Actions are payloads of information that send data from your application to your store.
    They are the only source of information for the store.

    Action creators are exactly that—functions that create actions.
*/

/**
 * Redux action creators defined for snb container component
 *
 * @author John Lukose <john.lukose@quikr.com>
 */

import EVENTS from '../../constants/events';


export const sortFilterItemClicked = (selectedFilter = 0) => ({
	type: EVENTS.SNB_CONTAINER_EVENTS.SORT_FILTER_ITEM_CLICKED,
	payload: { selectedFilter }
});

export const openSortFilter = () => ({
	type: EVENTS.SNB_CONTAINER_EVENTS.SORT_FILTER_CLICKED,
	payload: {}
});

export const closeSortFilter = () => ({
	type: EVENTS.SNB_CONTAINER_EVENTS.SORT_FILTER_CLOSED,
	payload: {}
});

export const openFilter = () => ({
	type: EVENTS.SNB_CONTAINER_EVENTS.FILTER_OPEN,
	payload: {}
});

export const filterMountedAction = (response) => ({
	type: EVENTS.SNB_CONTAINER_EVENTS.FILTER_MOUNTED,
	payload: { response }
});

export const closeFilter = () => ({
	type: EVENTS.SNB_CONTAINER_EVENTS.FILTER_CLOSE,
	payload: {}
});

export const resetFilter = () => ({
	type: EVENTS.SNB_CONTAINER_EVENTS.FILTER_RESET,
	payload: {}
});

export const prepareFilter = () => ({
	type: EVENTS.SNB_CONTAINER_EVENTS.FILTER_PREPARE,
	payload: {}
});

export const applyFilter = () => ({
	type: EVENTS.SNB_CONTAINER_EVENTS.FILTER_APPLY,
	payload: {}
});

export const filterJobs = () => ({
	type: EVENTS.SNB_CONTAINER_EVENTS.FILTER_JOBS,
	payload: {}
});

export const setClickedFilterItem = (key, multiValued, value, innerKey = '', isInnerMultiValued = '' , innerValue = '') => ({
	type: EVENTS.SNB_CONTAINER_EVENTS.FILTER_ITEM_CLICKED,
	payload: { key, multiValued, value, innerKey , isInnerMultiValued, innerValue }
});

export const toggleDisplayofInternalLinksTupple = (showHide) => {
	let data= {
		type : EVENTS.SNB_CONTAINER_EVENTS.RECEVED_SIMILAR_JOBS_AJAXDATA,
		payload : {showHide}
	};
	return data;
}

export const toggleNorthEasthCityFilter = (payload) => ({
	type: EVENTS.SNB_CONTAINER_EVENTS.NORTHEAST_MY_CITY,
	payload
});

export const updateNorthEastCityFilter = (payload) => ({
	type: EVENTS.SNB_CONTAINER_EVENTS.SHOW_NORTHEAST_CITY_FILTER,
	payload
});

export const updateFilterState = (payload) => ({
  type: EVENTS.SNB_CONTAINER_EVENTS.UPDATE_FILTER_STATE,
  payload: payload
});



// WEBPACK FOOTER //
// ../q-jobs/src/actions/SnbContainerActions/index.js